<template>
  <main class="flex flex-wrap gap-6 w-full">
    <slot />
  </main>
</template>
